const tweets = [
    {
        id:1,
        icon:"https://res.cloudinary.com/dke9xzbl6/image/upload/v1641629534/ze-te/Amreet_kumar_khuntia_2_qp4mot.png",
        name:"Amreet Kumar Khuntia",
        work:"Front-end Developer, Designer",
        description:"With increasing demands in food in everyday life especially during this epidemic time people have to suffer a lot. So, I along with my friends were wondering if we can make some website which would help NGOs/Government to easily collect left out food and distribute to the needed. As of now this is just an idea and we hope we can make it true one day."
    },
    {
        id:2,
        icon:"https://res.cloudinary.com/dzbdnlr0f/image/upload/v1638359763/shantanu-portfolio/Kumar_Shantanu_y3ktwt.jpg",
        name:"Kumar Shantanu",
        work:"Front-end Developer, Designer",
        description:"People often spend a lot in parties and don't look at the amount of food being wasted later on. So we came up with a idea where the food instead of getting wasted is distributed among the needy people. NGOs take the food from the parties as per the bookings and distribute it to the people who are in need."
    },
    {
        id:3,
        icon:"https://res.cloudinary.com/dke9xzbl6/image/upload/v1642871011/ze-te/Photo-1_lh4dlt.png",
        name:"Shreeansh Praharaj",
        work:"Content Writer, Designer",
        description:"Nowadays millions of people in the whole world is suffering from hunger and poverty. Though it is a huge problem, I think the young mass should irradicate it by taking necessary steps. I saw in different occasions huge amount of food being waste. If we distribute this food among poor and hungry people , they become happy and grateful to us. That's why I am intersted to work in this project with my friends."
    },
    
]

export {tweets};